<!-- Blockchain upload failures, downloaded as Excel (built in the browser).
     Hidden without the export privilege — see FailureReportDownloadComponent. -->
<ng-container *ngIf="canView">
    <!-- A plain button, not mat-icon-button: the count sits beside the icon
         instead of in a fixed-width Material badge, which clipped a 3-digit
         total down to a bare "+". The pill widens to whatever the count needs. -->
    <button type="button"
            class="m-r-5 failure-trigger"
            [class.is-clean]="openTotal === 0"
            [matMenuTriggerFor]="failureReports"
            (menuOpened)="loadSummary()"
            [matTooltip]="tooltip"
            [attr.aria-label]="ariaLabel">
        <mat-icon class="trigger-icon">cloud_download</mat-icon>
        <span class="trigger-count" *ngIf="openTotal > 0">{{ countText }}</span>
    </button>

    <mat-menu #failureReports="matMenu" class="failure-report-menu" xPosition="before" yPosition="below">
        <div class="failure-report-header" (click)="$event.stopPropagation()">
            <p class="title">Blockchain Failure Report</p>
            <p class="subtitle">Records that could not be registered on the blockchain — download as Excel</p>
        </div>

        <div *ngIf="loading" class="failure-report-state">
            <mat-spinner diameter="20"></mat-spinner>
            <span>Loading…</span>
        </div>

        <ng-container *ngIf="!loading">
            <!-- Everything still failing, whatever its date. Kept first because
                 never-processed and duplicate records are not daily events. -->
            <button mat-menu-item
                    *ngIf="openTotal > 0"
                    class="all-open-item"
                    [class.is-downloading]="downloading === 'all'"
                    [disabled]="downloading !== null"
                    (click)="download(allScope())">
                <mat-icon>{{ downloading === 'all' ? 'hourglass_top' : 'inventory_2' }}</mat-icon>
                <span class="report-row">
                    <span class="report-title">All open failures</span>
                    <span class="report-count">
                        <span>{{ openTotal }} record(s) still failing</span>
                        <span class="recovered" *ngIf="recoveredTotal">· {{ recoveredTotal }} recovered by scheduler</span>
                    </span>
                </span>
            </button>

            <div class="failure-report-list">
                <!-- Recent days, one row each -->
                <ng-container *ngIf="days.length">
                    <div class="group-label">Last {{ recentDays }} days</div>
                    <button mat-menu-item
                            *ngFor="let day of days"
                            [class.is-downloading]="downloading === key(dayScope(day))"
                            [disabled]="downloading !== null"
                            (click)="download(dayScope(day))">
                        <mat-icon>{{ downloading === key(dayScope(day)) ? 'hourglass_top' : 'grid_on' }}</mat-icon>
                        <span class="report-row">
                            <span class="report-title">
                                {{ formatDate(day.date) }}
                                <span class="today-tag" *ngIf="isToday(day.date)">today</span>
                            </span>
                            <span class="report-count">
                                <span [class.zero]="day.failures === 0">{{ day.failures }} failed</span>
                                <span class="recovered" *ngIf="day.recovered">· {{ day.recovered }} recovered</span>
                            </span>
                        </span>
                    </button>
                </ng-container>

                <!-- Older failures folded into months, so nothing in the badge
                     total is left without a row to download it from. -->
                <ng-container *ngIf="months.length">
                    <div class="group-label">Earlier</div>
                    <button mat-menu-item
                            *ngFor="let month of months"
                            [class.is-downloading]="downloading === key(monthScope(month))"
                            [disabled]="downloading !== null"
                            (click)="download(monthScope(month))">
                        <mat-icon>{{ downloading === key(monthScope(month)) ? 'hourglass_top' : 'calendar_month' }}</mat-icon>
                        <span class="report-row">
                            <span class="report-title">{{ formatMonth(month.month) }}</span>
                            <span class="report-count">
                                <span [class.zero]="month.failures === 0">{{ month.failures }} failed</span>
                                <span class="recovered" *ngIf="month.recovered">· {{ month.recovered }} recovered</span>
                            </span>
                        </span>
                    </button>
                </ng-container>
            </div>

            <div *ngIf="!hasBuckets" class="failure-report-state">
                <mat-icon class="ok-icon">check_circle</mat-icon>
                <span>No failed records — nothing to download</span>
            </div>

            <mat-divider></mat-divider>

            <!-- The menu answers "how many / give me the Excel". The full page
                 is for working through the records with a date filter. -->
            <button mat-menu-item class="full-page-item" (click)="openFullReport()">
                <mat-icon>open_in_new</mat-icon>
                <span class="report-row">
                    <span class="report-title">View full report</span>
                    <span class="report-hint">Filter by date, search and browse all records</span>
                </span>
            </button>
        </ng-container>
    </mat-menu>
</ng-container>
